import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ThemeColorVariable, } from '@caspeco/casper-ui-library.base-ui.theme';
import { Flex, Radio as ChakraRadio, } from '@chakra-ui/react';
import { hoverStyles } from './radio.hoverstyles';
/**
 * Radio component is used in forms when a user needs to select a single value from several options.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/radio
 */
export const Radio = React.forwardRef(({ value, children, defaultChecked, onChange, isChecked, isInvalid, isDisabled, ...props }, ref) => {
    return (_jsx(Flex, { __css: hoverStyles, ...props, children: _jsx(ChakraRadio, { ref: ref, value: value, defaultChecked: defaultChecked, isChecked: isChecked, onChange: onChange, isInvalid: isInvalid, isDisabled: isDisabled, w: "100%", _invalid: {
                borderColor: ThemeColorVariable.Error,
                boxShadow: `0 0 0 4px ${ThemeColorVariable.ErrorContainer}`,
            }, _active: {
                borderColor: `${ThemeColorVariable.AccentActive}`,
                _checked: {
                    background: `${ThemeColorVariable.AccentActive}`,
                    borderColor: `${ThemeColorVariable.AccentActive}`,
                },
                _disabled: {
                    borderColor: `${ThemeColorVariable.OnBackground}`,
                    _checked: {
                        background: `${ThemeColorVariable.Accent}`,
                        borderColor: `${ThemeColorVariable.Accent}`,
                    },
                },
            }, children: children }, value) }));
});
//# sourceMappingURL=radio.js.map